import { createSelector } from 'reselect';
import { getBusinessDetails } from '@/selectors/merchant';
import { getLookupData } from '@/selectors/lookupData';

export const getDefaultState = createSelector(
  getBusinessDetails,
  getLookupData,
  ({ companyName, address, operatingAddress }, { businessDetails = {} }) => ({
    companyName: companyName || businessDetails.companyName,
    address: address || businessDetails.address,
    operatingAddress,
    isLookup:
      (!companyName && !!businessDetails.companyName) || (!address && !!businessDetails.address),
  }),
);
